import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check localStorage on mount. Prefer new key `tyretrack_user`, fallback and migrate from `tiretrack_user`.
  useEffect(() => {
    const currentVersion = process.env.REACT_APP_VERSION;
    const storedVersion = localStorage.getItem("tyretrack_version");
    
    // Se la versione è cambiata, forza il logout
    if (storedVersion && storedVersion !== currentVersion) {
      console.log(`Versione cambiata da ${storedVersion} a ${currentVersion}. Logout forzato.`);
      localStorage.removeItem("tyretrack_user");
      localStorage.removeItem("tiretrack_user");
      localStorage.setItem("tyretrack_version", currentVersion);
      setUser(null);
      setLoading(false);
      return;
    }

    // Imposta la versione se non esiste
    if (!storedVersion) {
      localStorage.setItem("tyretrack_version", currentVersion);
    }

    const newKey = localStorage.getItem("tyretrack_user");
    const oldKey = localStorage.getItem("tiretrack_user");

    if (newKey) {
      try {
        setUser(JSON.parse(newKey));
      } catch (e) {
        localStorage.removeItem("tyretrack_user");
      }
    } else if (oldKey) {
      // migrate old stored user to new key to keep compatibility
      try {
        const parsed = JSON.parse(oldKey);
        setUser(parsed);
        localStorage.setItem("tyretrack_user", JSON.stringify(parsed));
      } catch (e) {
        localStorage.removeItem("tiretrack_user");
      }
    }

    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    // keep both keys in sync for backward compatibility
    localStorage.setItem("tyretrack_user", JSON.stringify(userData));
    localStorage.setItem("tiretrack_user", JSON.stringify(userData));
    // Memorizza anche la versione corrente al login
    localStorage.setItem("tyretrack_version", process.env.REACT_APP_VERSION);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("tyretrack_user");
    localStorage.removeItem("tiretrack_user");
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
